module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/2-e5c50465a38fe8dcdeba3a2acb73f658.jpeg";